import { render } from "./PopupContainer.vue?vue&type=template&id=f6bf6da0&scoped=true"
import script from "./PopupContainer.vue?vue&type=script&lang=js"
export * from "./PopupContainer.vue?vue&type=script&lang=js"

import "./PopupContainer.vue?vue&type=style&index=0&id=f6bf6da0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6bf6da0"]])

export default __exports__